import React, { Component } from "react";
import Apihelpers from './../helper/ApiHelper';
import $ from "jquery";
import {POST_MASTER_SERVICE_EDIT, POST_MASTER_SERVICE_DOC_REMOVE, MASTER_SERVICE_CAT} from './../helper/Constants';

export default class MasterServicesEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editRecord: this.props.editRecord,
      allPlans:this.props.allPlans
    }
  }

  editFormSubmitFun = (e) => {
    e.preventDefault();
    if(!this.state.editRecord.name.replace(/\s+/g, '')) {
      alert('Please add valid name');
      return;
    }
    const formData = new FormData();
    formData.append("id", this.state.editRecord.id);
    formData.append("name", this.state.editRecord.name);
    formData.append("cat", this.state.editRecord.cat);
    formData.append("useType", this.state.editRecord.useType);
    formData.append("source", this.state.editRecord.source);
    formData.append("service_url", this.state.editRecord.srUrl);
    formData.append("desc", this.state.editRecord.desc);
    formData.append("traversing_dependency", this.state.editRecord.traDep);
    if (this.state.editRecord.traDep === 'child') {
      formData.append("parent_id", JSON.stringify($("#multiSelect").select2("val")));
    }
    if(this.state.editRecord.docNew !== "") {
      if(this.state.editRecord.docNew.name.replace(/^.*\./, '').toLowerCase() !== "pdf") {
        alert('Please add valid pdf file');
        return;
      }
      formData.append("doc", this.state.editRecord.docNew);
    }

    //console.log('selected array',JSON.stringify($("#multiSelect").select2("val")));
    //return;
    
    this.props.toggleLoader();
    console.log('call update api....');
    Apihelpers.postdataresponseMultipart(POST_MASTER_SERVICE_EDIT,formData)
    .then((res)=>{
      console.log('res',res.data);
      if(res.data.status === true) {
        this.props.editTogglePopup();
        this.props.loadPlanes();
      }
    }).catch((error)=> {
      console.log('error',error);
    });
  }

  unLinkFileFun = (id,doc) => {
    console.log('id',id,'  ,doc:',doc);
    let dataObj = {'id':id,'doc':doc};
    Apihelpers.postdataresponse(POST_MASTER_SERVICE_DOC_REMOVE,dataObj).then((res)=>{
      console.log('res.data',res.data);
      if(res.data.status === true) {
        this.setState({
          editRecord: {...this.state.editRecord, doc: ""}
        })
      }
    }).catch((error)=> {
      console.log('error',error);
    });
  }
  render() {
    return (
      <div className="customPopup" style={{ 'display': 'block' }}>
        <div className="bgLayer" />
        <div className="popUpBox" style={{ maxWidth: "770px" }}>
          <span className="closeIcon" onClick={this.props.editTogglePopup}> </span>
          <div className="popScroll" style={{ padding: "20px 25px 16px 25px" }}>
            {
              //JSON.stringify(this.state.editRecord, null, 2)
            }
            <div className="popUpHed">
              <h3>Update Plan</h3>
            </div>
            <form className="form" method="post" onSubmit={this.editFormSubmitFun}>
              <div className="row">
                <div className="col-md-6">
                  <div className="row g-1">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="control-title">Sequence No.<span className="ex">*</span></label>
                        <input type="number" className="form-control" readOnly defaultValue={this.state.editRecord.sr} />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <label className="control-title">Key <span>should be key format</span> <span className="ex">*</span></label>
                        <input type="text" className="form-control" readOnly defaultValue={this.state.editRecord.key} placeholder="enter plan key" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Name <span className="ex">*</span></label>
                    <input type="text" className="form-control" placeholder="enter plan name" required onChange={(e) => {
                      this.setState({ editRecord: { ...this.state.editRecord, "name": e.target.value } })
                    }} defaultValue={this.state.editRecord.name} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row g-1">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="control-title">Use Type <span className="ex">*</span></label>
                        <select className="form-control" required onChange={(e) => {
                          this.setState({ editRecord: { ...this.state.editRecord, "useType": e.target.value } })
                        }} defaultValue={this.state.editRecord.useType} >
                          <option value="api">API</option>
                          <option value="panel">Panel</option>
                        </select>

                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <label className="control-title">Source <span className="ex">*</span></label>
                        <select className="form-control" required onChange={(e) => {
                          this.setState({ editRecord: { ...this.state.editRecord, "source": e.target.value } })
                        }} defaultValue={this.state.editRecord.source}>
                          <option value="free">Free</option>
                          <option value="paid">Paid</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Category <span className="ex">*</span></label>
                    <select className="form-control" required onChange={(e) => {
                      this.setState({ editRecord: { ...this.state.editRecord, "cat": e.target.value } })
                    }} defaultValue={this.state.editRecord.cat}>
                      {
                        MASTER_SERVICE_CAT.map((obj)=>{
                          return(<option key={obj.slug} value={obj.slug}>{obj.label}</option>)
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">API URL <span className="ex">*</span></label>
                    <div className="inputGroup inputGroupNew">
                      <span className="inputIcon">{Apihelpers.getBaseUrl()}</span>
                      <input className="form-control" required placeholder="enter url" onChange={(e)=>{this.setState({editRecord: { ...this.state.editRecord, "srUrl": e.target.value }})}} pattern="^\S+$" defaultValue={this.state.editRecord.srUrl} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row g-1">
                    <div className="col-md-8">
                      <div className="form-group">
                        <label className="control-title">Document <span className="ex">*</span></label>
                        {
                          (this.state.editRecord.doc === undefined || this.state.editRecord.doc === "") ?
                            <input type="file" required className="form-control" onChange={(e) => {
                              this.setState({ editRecord: { ...this.state.editRecord, "docNew": e.target.files[0] } })
                            }} accept="application/pdf" />
                            :
                            <div>
                              <a className="btn-icon light" target="_blank" href={`${Apihelpers.getBaseUrl()+'api_documents/'+this.state.editRecord.doc}`} title="View Document"><i className="fa fa-file-text-o"></i></a> &nbsp;
                              <button className="btn-icon light" onClick={() => { this.unLinkFileFun(this.state.editRecord.id, this.state.editRecord.doc) }} type="button" title="Remove Document"><i className="fa fa-trash-o"></i></button>
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Description</label>
                    <textarea className="form-control" placeholder="enter description" rows="3" onChange={(e) => {
                      this.setState({ editRecord: { ...this.state.editRecord, "desc": e.target.value } })
                    }} defaultValue={this.state.editRecord.desc} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Traversing Dependency</label>
                    <select className="form-control" onChange={(e) => {
                      this.setState({ editRecord: { ...this.state.editRecord, "traDep": e.target.value } })
                    }} defaultValue={this.state.editRecord.traDep} >
                      <option value="parent">Parent (No Dependency)</option>
                      <option value="child">Child (Dependency)</option>
                    </select>
                  </div>
                  {(()=>{
                    if (this.state.editRecord.traDep === 'child') {
                      let selected = this.state.editRecord.parent_id;
                      if(selected === undefined && selected === null) {
                        selected = [''];
                      }
                      console.log('selected',selected);
                      setTimeout(function () {
                        $("#multiSelect").select2({
                          placeholder: "type plan name",
                          tags: false,
                          //tokenSeparators: [',', ' ']
                        });
                      }, 100);
                      return(
                        <div className="form-group">
                          <label className="control-title">Parent Plan <span className="ex">*</span></label>
                          <select className="form-control" required multiple="multiple" id="multiSelect" style={{ width: "100%" }} defaultValue={selected}>
                            {
                              this.state.allPlans.map((itm)=>{
                                if(itm.serviceName === this.state.editRecord.key) {
                                  return;
                                }
                                return(<option key={itm._id} value={itm._id}>{itm.serviceName}</option>)
                              })
                            }
                          </select>
                        </div>
                      );
                    }
                  })()}
                </div>
              </div>
              <div className="submitRow">
                <button className="backBtn" type="button" onClick={this.props.editTogglePopup}>Cancel</button>
                <button className="blueBtn" type="submit">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}